import React from 'react';

const AdminIcon: React.FC<{size?: number; color?: string}> = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 3L16 6V10C16 13.8 13.6 16.8 10 18C6.4 16.8 4 13.8 4 10V6L10 3Z" stroke={color} strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M8 10L9.5 11.5L12.5 8.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default AdminIcon;
